import axios from 'axios';
import _e from './_endpoints';

const getReportsUrl = _e.getUrl('reports');
const getReportGUIDURL = _e.getUrl('reportGUID');
const getReportPDFURL = _e.getUrl('reportPDF');

const getReportUrl = (id:string) => `${_e.getUrl('report')}/${id}`;

const getReportGuidUrl = (id:string) => `${getReportGUIDURL}/${id}`;
const getReportPdfUrl = (id:string) => `${getReportPDFURL}/${id}`;

const getReports = () => axios.get(getReportsUrl);
const getReport = (id:string) => axios.get(getReportUrl(id)); 

const getReportGUID = (id:string) => axios.get(getReportGuidUrl(id)); 
const getReportPDF = (id:string) => axios.get(getReportPdfUrl(id)); 

export default {
    getReports,
    getReport,
    getReportGUID,
    getReportPDF
}